import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
// @ts-ignore
import quote from "../../images/homePage/quote-right.svg";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "swiper/css";
import "swiper/css/pagination";
import BlueLinkedInIcon from "../svg/blueLinkedInIcon.svg";
import trackScrollEvent from "../../util/trackScrollEvent";
import { Link } from "gatsby";

const Project: React.FC<any> = (client) => {
  const [isInRange, setInRange] = useState<any>(false);

  const handleScroll = () => {
    setInRange(trackScrollEvent(10, client.id));
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <div
        id={client.id}
        className={classNames("my-[40px] lg:flex lg:items-start", {
          // "lg:flex-row": client.invert,
          "lg:flex-row-reverse": client.invert === 0,
        })}
        style={{ margin: "auto", width: "100%" }}
      >
        <Swiper
          key={`${isInRange}`}
          style={{
            // @ts-ignore
            "--swiper-pagination-color": "#40BA77",
          }}
          pagination={{ dynamicBullets: true }}
          modules={[Pagination, Autoplay]}
          className={"rounded-[20px] lg:w-2/4"}
          autoplay={isInRange}
        >
          {client?.attributes?.projectImages?.[0]?.media?.data?.map(
            (image: any) => (
              <SwiperSlide key={image?.attributes?.url}>
                <div className="lg:w-185 aspect-[1.09/1]l mx-[4px] my-8 w-full shrink-0 rounded-3xl lg:pt-16">
                  <img
                    src={`${image?.attributes?.url}`}
                    alt={client?.attributes?.proectImages?.[0]?.altText}
                    className="aspect-[1.09/1] w-full"
                  />
                </div>
              </SwiperSlide>
            )
          )}
        </Swiper>
        <div
          className={classNames(
            "mx-[4px] my-auto py-8 lg:w-2/4 lg:pt-16",
            {
              "lg:ml:[60px] lg:pl-[80px] lg:pr-[10px]": client?.invert,
            },
            {
              "lg:mr-[60px] lg:pl-[0px] lg:pr-[60px]": !client?.invert,
            }
          )}
        >
          <p
            className={
              "text-[14px] leading-[19.5px] text-black-400 lg:text-[16px] lg:leading-[24px]"
            }
          >
            {client?.attributes?.clientsData?.[0]?.location}
          </p>
          <p
            className={
              "relative text-[20px] font-medium text-black-400 lg:text-[35px] lg:leading-[52.5px]"
            }
          >
            <Link to={`/portfolio/${client?.attributes?.slug || client.id}`}>
              {client?.attributes?.name}&nbsp;&nbsp;
            </Link>
            <span
              className={
                " -bottom-0.5 text-[14px] font-light text-gray-200 lg:text-[18px]"
              }
            >
              {/* project time duration like :-( Duration 6 months) */}
              {}
            </span>
          </p>
          <p
            className={
              "pt-3 text-sm text-description-darker md:w-4/5 lg:w-full lg:text-[20px] lg:font-medium lg:font-normal lg:leading-[33px]"
            }
          >
            {client?.attributes?.description}
          </p>
          <div
            className={
              "mb-11 flex flex-col-reverse lg:flex-row lg:gap-x-3 lg:p-2"
            }
          >
            <div className={"flex flex-col lg:basis-3/5 lg:p-2"}>
              <span
                className={classNames(
                  "mt-4 text-[14px] font-medium leading-[27px] text-black-400 lg:text-[18px]"
                )}
              >
                Tech used
              </span>
              <div
                className={
                  "flex w-full flex-wrap gap-[20px] lg:mt-6 lg:w-full lg:gap-[25px]"
                }
              >
                {client?.attributes?.techUsed?.data?.map((techData: any) => {
                  return (
                    <div
                      className={"w-[auto] lg:h-[50px]"}
                      key={
                        techData?.attributes?.imageData?.media?.data?.[0]
                          ?.attributes?.url
                      }
                    >
                      <img
                        className={
                          "h-[40px] w-[40px] lg:h-[40px] lg:w-[40px] xl:h-[50px] xl:w-[60px]"
                        }
                        style={{
                          display: "block",
                          objectFit: "contain",
                        }}
                        src={`${techData?.attributes?.imageData?.media?.data?.[0]?.attributes?.url}`}
                        alt={"techdata"}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              className={classNames(
                "flex gap-x-[12px] pt-[14px] lg:flex lg:basis-2/5 lg:flex-col lg:p-2"
              )}
            >
              <span
                className={classNames(
                  "text-[14px] font-medium leading-[27px] text-black-400 lg:mt-4 lg:text-[18px]"
                )}
              >
                Platform
              </span>
              <div className={"flex flex-wrap items-center gap-[20px] lg:mt-6"}>
                {client?.attributes?.platform?.data?.map((techData: any) => {
                  return (
                    <div
                      className={"lg:h-[50px] lg:w-[auto]"}
                      key={
                        techData?.attributes?.imageData?.media?.data?.[0]
                          ?.attributes?.url
                      }
                    >
                      <img
                        className={
                          "h-[25px] w-[25px] lg:h-[40px] lg:w-[40px] xl:h-[45px] xl:w-[45px]"
                        }
                        style={{
                          display: "block",
                          objectFit: "contain",
                        }}
                        src={`${techData?.attributes?.imageData?.media?.data?.[0]?.attributes?.url}`}
                        alt={"techdata"}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {client?.attributes?.clientsData?.length &&
          client?.attributes?.clientsData[0].feedback ? (
            <div style={{ margin: 0 }}>
              <div className={"relative  lg:relative lg:block"}>
                <Swiper
                  className={
                    "z-10 flex place-items-start justify-self-start rounded-md border-[1px] border-green-400 bg-white "
                  }
                >
                  {client?.attributes?.clientsData?.map((clientData: any) => (
                    <SwiperSlide
                      key={clientData?.name}
                      className={classNames(
                        "flex items-center gap-[10px] p-4",
                        {
                          "bg-green-500": client?.invert,
                        }
                      )}
                    >
                      {clientData?.imageData?.media?.data?.length && (
                        <img
                          style={{ borderRadius: "50%" }}
                          src={`${clientData?.imageData?.media?.data?.[0]?.attributes?.url}`}
                          className={
                            clientData?.imageData?.media?.data?.[0]?.attributes
                              ?.url.length === 0
                              ? "hidden"
                              : "h-[60px] w-[60px] min-w-[60px] items-center rounded-full object-cover lg:h-[96px] lg:w-[96px] lg:min-w-[96px]"
                          }
                          alt={`${clientData?.imageData?.media?.data?.[0]?.attributes?.altText}`}
                        />
                      )}
                      <div className={"flex flex-col"}>
                        <div
                          className={"flex flex-wrap items-center gap-[10px]"}
                        >
                          <p
                            className={
                              "text-[15px] font-medium leading-[30px] text-primary lg:text-[20px]"
                            }
                          >
                            <a href={clientData?.linkedIn} target="_blank">
                              <div
                                className={"flex items-center justify-between"}
                              >
                                <span className={"mr-2"}>
                                  {" "}
                                  {clientData?.name}
                                </span>
                                {clientData?.linkedIn && (
                                  <BlueLinkedInIcon width={20} height={20} />
                                )}
                              </div>
                            </a>
                          </p>
                          <p
                            className={
                              "text-[13px] font-light leading-[19.5px] text-black-400"
                            }
                          >
                            <span> {clientData?.position} </span>
                          </p>
                        </div>

                        <div>
                          <p
                            className={"text-sm text-black-400"}
                            style={{
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box !important",
                              // @ts-ignore
                              "-webkit-line-clamp": "2",
                              "-webkit-box-orient": "vertical",
                            }}
                          >
                            {clientData?.feedback}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <img
                  src={quote}
                  className={"absolute left-[0px] -top-[18px] z-10"}
                  alt={"quote icon"}
                />
                <img
                  src={quote}
                  className={
                    "absolute -bottom-[18px] -right-[0px] z-10 rotate-180"
                  }
                  alt={"quote icon"}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Project;
